export interface FormResponse {
    id: number;
    title: string;
    description: string;
    background: string;
    buttons: string;
    gaTrackingCode: string;
    image: string;
    allowOpenEntry: boolean;
    allowAnonymousEntries: boolean;
    receiveReportByEmail: boolean;
    allowRestart: boolean;
    updated: string;
}

export class Form {
    public id: number;
    public title: string;
    public description: string;
    public background: string;
    public buttons: string;
    public gaTrackingCode: string;
    public image: string;
    public allowOpenEntry: boolean;
    public allowAnonymousEntries: boolean;
    public receiveReportByEmail: boolean;
    public updated: number;
    public allowRestart: boolean;

    constructor(data: FormResponse) {
        this.id = data.id;
        this.title = data.title;
        this.description = data.description;
        this.background = data.background;
        this.buttons = data.buttons;
        this.gaTrackingCode = data.gaTrackingCode;
        this.image = data.image;
        this.allowOpenEntry = data.allowOpenEntry;
        this.allowAnonymousEntries = data.allowAnonymousEntries;
        this.allowRestart = data.allowRestart;
        this.receiveReportByEmail = data.receiveReportByEmail;
        this.updated = parseInt(data.updated, 10);
    }
}

export interface FormElementResponse {
    id: number;
    title: string;
    type: string;
    description: string;
    params: FormElementData;
    tags: FormElementTagResponse[];
}

export interface FormElementTagResponse {
    id: number;
    title: string;
    hex: string;
}

export class FormElementTag {
    public id: number;
    public title: string;
    public hex: string;
    public points = 0;

    constructor(data: FormElementTagResponse) {
        this.id = data.id;
        this.title = data.title;
        this.hex = data.hex;
    }
}

export class FormElement {
    public id: number;
    public title: string;
    public description: string;
    public type: string;
    public params: FormElementData;
    public tags: FormElementTag[];

    constructor(data: FormElementResponse) {
        this.id = data.id;
        this.title = data.title;
        this.description = data.description;
        this.type = data.type;
        this.params = new FormElementData(data.params);
        this.tags = data.tags && data.tags.map((tag: FormElementTagResponse) => new FormElementTag(tag));
    }
}

export class FormElementData {
    public body: string;
    public placeholder: string;
    public min: number;
    public max: number;
    public options: object[];
    public description: string;
    public isMultiple: boolean;

    constructor({ body, placeholder, min, max, options, description, isMultiple }: any) {
        this.body = body;
        this.placeholder = placeholder;
        this.min = min;
        this.max = max;
        this.options = options;
        this.description = description;
        this.isMultiple = isMultiple || false;
    }
}
